// extracted by mini-css-extract-plugin
export default {"checkboxGroup":"Fbn7sYhtV51C8dHHJ_bO"};